import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import Draggable from "./components/Draggable";
import ChatHeader from "./components/ChatHeader";
import ChatInputContainer from "./ChatInputContainer";
import ChatSuggestions from "./components/ChatSuggestions";
import ChatView from "./components/ChatView";
import RatingView from "./components/RatingView";
import EndingView from "./components/EndingView";
import FinalView from "./components/FinalView";
import QueueView from "./components/QueueView";
import LeavingQueueView from "./components/LeavingQueueView";
import AdvisorsBusy from "./components/AdvisorsBusy";
import CallCenterClosed from "./components/CallCenterClosed";
import ErrorView from "./components/ErrorView";
import { hideChatPanel, closeChat } from "./features/ChatBarActions";
import { onClickSend, returnToChat, endChat, endingChat, useSuggestion, fetchUpdateRating, skipSubmitRating, useRichContent, fetchTranscript, savePosition, leaveQueue, cycleQueueMessage, leavingQueue, backToQueue, resetChatState, resetConfigState } from "./features/ChatActions";
import { fetchChatEnd } from "./features/LiveActions";
import { withChatContext } from "./Context";
import { CHAT_STATUS } from "./constants";
class ChatContainer extends Component {
  constructor(props) {
    super(props);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onMinimizeClick = this.onMinimizeClick.bind(this);
    this.onSuggestionClick = this.onSuggestionClick.bind(this);
    this.onRichContentClick = this.onRichContentClick.bind(this);
    this.onReturnToChatClick = this.onReturnToChatClick.bind(this);
    this.onEndChatClick = this.onEndChatClick.bind(this);
    this.onRatingSubmit = this.onRatingSubmit.bind(this);
    this.onRatingSkip = this.onRatingSkip.bind(this);
    this.onGetTranscript = this.onGetTranscript.bind(this);
    this.savePosition = this.savePosition.bind(this);
    this.onLeaveQueue = this.onLeaveQueue.bind(this);
    this.onLeavingQueue = this.onLeavingQueue.bind(this);
    this.onBackToQueue = this.onBackToQueue.bind(this);
    this.onTryAgainClick = this.onTryAgainClick.bind(this);
    this.isSuggestionsShown = this.isSuggestionsShown.bind(this);
    this.props.dispatch(cycleQueueMessage());
  }
  componentWillUnmount() {
    const {
      dfCaseId
    } = this.props.chat.chatBot;
    if (dfCaseId) {
      this.props.dispatch(fetchChatEnd(this.props.apiClient));
    }
    this.props.dispatch(resetChatState());
    this.props.dispatch(resetConfigState());
  }
  isSuggestionsShown() {
    return this.props.chat.chatBot.suggestions.length && !this.props.chat.chatBot.dfCaseId;
  }
  isMobileDevice() {
    return !!(navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i));
  }
  savePosition(bottom, right) {
    this.props.dispatch(savePosition(bottom, right));
  }
  onMinimizeClick() {
    this.props.dispatch(hideChatPanel());
  }
  onCloseClick() {
    const finalClose = this.props.chat.chatBot.state === CHAT_STATUS.ENDED || this.props.chat.chatBot.state === CHAT_STATUS.FINAL;
    if (finalClose) {
      this.props.dispatch(closeChat());
    } else {
      this.props.dispatch(endingChat());
    }
  }
  onSuggestionClick(suggestion) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    this.props.dispatch(useSuggestion(suggestion));
    this.props.dispatch(onClickSend({
      message: suggestion,
      parcelCode: this.props.chat.config.parcelCode,
      apiClient: this.props.apiClient
    }));
  }
  onRichContentClick(suggestion) {
    setTimeout(() => {
      this.props.dispatch(useRichContent(suggestion));
      this.props.dispatch(hideChatPanel());
    }, 500);
  }
  onReturnToChatClick() {
    this.props.dispatch(returnToChat());
  }
  onEndChatClick() {
    const {
      dispatch,
      apiClient,
      chat
    } = this.props;
    if (chat.chatBot.dfCaseId) {
      dispatch(fetchChatEnd(apiClient));
    }
    dispatch(endChat());
  }
  onRatingSubmit(rating, notes) {
    this.props.dispatch(fetchUpdateRating(rating, notes, this.props.apiClient));
  }
  onRatingSkip() {
    this.props.dispatch(skipSubmitRating());
  }
  onGetTranscript() {
    this.props.dispatch(fetchTranscript(this.props.apiClient));
  }
  onLeavingQueue() {
    this.props.dispatch(leavingQueue());
  }
  onBackToQueue() {
    this.props.dispatch(backToQueue());
  }
  onLeaveQueue() {
    this.props.dispatch(fetchChatEnd(this.props.apiClient));
    this.props.dispatch(leaveQueue());
    this.props.chat.chatBot.dfQueue > 0 && this.onMinimizeClick();
  }
  onTryAgainClick() {
    this.props.dispatch(returnToChat());
  }
  render() {
    if (this.props.show === false) {
      document.body.className = document.body.className.replace("prevent-scroll", "");
      return null;
    }
    if (document.body.className.indexOf("prevent-scroll") === -1) {
      document.body.className += " prevent-scroll";
    }
    let currentView = /*#__PURE__*/React.createElement("div", {
      className: "chat-core-screen"
    }, /*#__PURE__*/React.createElement(ChatView, {
      messages: this.props.chat.chatBot.messageHistory || [],
      previousmessages: this.props.chat.chatBot.previousMessages || [],
      agenttyping: !!(this.props.chat.chatBot.dfTyping || "").toString()
    }), /*#__PURE__*/React.createElement(ChatInputContainer, null), /*#__PURE__*/React.createElement(ReactCSSTransitionGroup, {
      transitionName: "example",
      transitionEnterTimeout: 300,
      transitionLeaveTimeout: 300
    }, this.isSuggestionsShown() && /*#__PURE__*/React.createElement(ChatSuggestions, {
      current: this.props.chat.chatBot.currentSuggestion,
      suggestions: this.props.chat.chatBot.suggestions,
      onSuggestionClick: this.onSuggestionClick,
      onRichContentClick: this.onRichContentClick,
      richContent: this.props.chat.chatBot.richContent,
      businessUnit: this.props.chat.chatBot.businessUnit,
      fmpPending: this.props.chat.chatBot.actionPending,
      key: 1
    })));
    if (this.props.chat.chatBot.state === CHAT_STATUS.ENDING) {
      currentView = /*#__PURE__*/React.createElement(EndingView, {
        onEndChatClick: this.onEndChatClick,
        onReturnToChatClick: this.onReturnToChatClick
      });
    }
    if (this.props.chat.chatBot.state === CHAT_STATUS.ENDED) {
      currentView = /*#__PURE__*/React.createElement(RatingView, {
        transcriptUrl: this.props.chat.config.transcriptUrl,
        onSubmit: this.onRatingSubmit,
        onSkip: this.onRatingSkip,
        hadFmpAction: this.props.chat.chatBot.hadFmpAction,
        getTranscript: this.onGetTranscript
      });
    }
    if (this.props.chat.chatBot.state === CHAT_STATUS.FINAL) {
      currentView = /*#__PURE__*/React.createElement(FinalView, null);
    }
    if (this.props.chat.chatBot.state === CHAT_STATUS.QUEUE && this.props.chat.chatBot.dfQueue > 0) {
      currentView = /*#__PURE__*/React.createElement(QueueView, {
        queuePosition: this.props.chat.chatBot.dfQueue,
        wait: this.props.chat.chatBot.averageWaitTime || 0,
        message: this.props.chat.chatBot.queueMessage,
        queuePositionMessages: this.props.chat.chatBot.queuePositionMessages,
        leaveQueue: this.onLeavingQueue
      });
    }
    if (this.props.chat.chatBot.state === CHAT_STATUS.LEAVING_QUEUE) {
      currentView = /*#__PURE__*/React.createElement(LeavingQueueView, {
        onLeave: this.onLeaveQueue,
        onBack: this.onBackToQueue
      });
    }
    if (this.props.chat.chatBot.state === CHAT_STATUS.ADVISOR_BUSY) {
      const accountEntry = this.props.chat.config.accountData.find(account => {
        return account.accountId === this.props.chat.config.accountNumber;
      });
      const accountQueue = accountEntry ? accountEntry.queue : "Elite";
      currentView = /*#__PURE__*/React.createElement(AdvisorsBusy, {
        queue: accountQueue,
        onLeave: this.onEndChatClick,
        onBack: this.onLeaveQueue
      });
    }
    if (this.props.chat.config.outOfHours === true || this.props.chat.chatBot.state === CHAT_STATUS.CALL_CENTER_CLOSED) {
      const accountEntry = this.props.chat.config.accountData.find(account => {
        return account.accountId === this.props.chat.config.accountNumber;
      });
      const accountQueue = accountEntry ? accountEntry.queue : "Elite";
      currentView = /*#__PURE__*/React.createElement(CallCenterClosed, {
        queue: accountQueue,
        onLeave: this.onEndChatClick,
        onBack: this.onLeaveQueue,
        message: this.props.chat.chatBot.dfClosedMessage
      });
    }
    if (this.props.chat.chatBot.state === CHAT_STATUS.NO_CASE_CODE) {
      currentView = /*#__PURE__*/React.createElement(ErrorView, {
        onTryAgainClick: this.onTryAgainClick
      });
    }
    return /*#__PURE__*/React.createElement(Draggable, {
      handle: "chat-header",
      disabled: this.isMobileDevice(),
      savePosition: this.savePosition,
      positionRight: this.props.chat.chatBot.positionRight,
      positionBottom: this.props.chat.chatBot.positionBottom
    }, /*#__PURE__*/React.createElement("div", {
      id: "chat-container"
    }, /*#__PURE__*/React.createElement(ChatHeader, {
      onCloseClick: this.onCloseClick,
      onMinimizeClick: this.onMinimizeClick,
      businessUnit: this.props.chat.config.businessUnit,
      showCloseButton: this.props.chat.config.outOfHours === true || [CHAT_STATUS.FINAL, CHAT_STATUS.ADVISOR_BUSY, CHAT_STATUS.CALL_CENTER_CLOSED].indexOf(this.props.chat.chatBot.state) === -1
    }), currentView));
  }
}
ChatContainer.propTypes = {
  dispatch: PropTypes.func,
  show: PropTypes.bool,
  businessUnit: PropTypes.number,
  config: PropTypes.object,
  chat: PropTypes.object,
  apiClient: PropTypes.object
};
function mapStateToProps(state) {
  return state;
}
export default withChatContext(connect(mapStateToProps)(ChatContainer));